export const fits = [
  {
    id: 'fit-1',
    name: 'Dickies Lined Eisenhower Jacket',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Dickies+Jacket',
    price: 159
  },
  {
    id: 'fit-2',
    name: 'Nike ACG Wolf Tree Full Zip Fleece',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Nike+ACG+Fleece',
    price: 265
  },
  {
    id: 'fit-3',
    name: 'Barbour SL Spey Showerproof Jacket',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Barbour+Jacket',
    price: 309
  },
  {
    id: 'fit-4',
    name: 'Polo Ralph Lauren Windbreaker Harrington',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Polo+Ralph+Lauren',
    price: 329
  },
  {
    id: 'fit-5',
    name: 'Carhartt WIP Detroit Jacket',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Carhartt+WIP',
    price: 409
  },
  {
    id: 'fit-6',
    name: 'Daily Paper Jacob Denim Jacket',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Daily+Paper',
    price: 319
  },
  {
    id: 'fit-7',
    name: 'Montane Spirit Gore-Tex Jacket',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Montane+Spirit',
    price: 385
  },
  {
    id: 'fit-8',
    name: 'Nike x NOCTA Cardinal Stock Woven Track Jacket',
    imageUrl: 'https://via.placeholder.com/240x240.png?text=Nike+NOCTA',
    price: 229
  }
];
